import React from "react";
import {
  ESTADO_LABELS,
  ESTADO_TONES,
  ORIGEN_LABELS,
  PRIORIDAD_LABELS,
  PRIORIDAD_LEVELS,
  codeOf,
  labelFor,
} from "../rolloFormat";

// StatusChip: rounded chip with a dot. The word is always written, color is never the only signal.
export function StatusChip({ estado }) {
  const tone = ESTADO_TONES[codeOf(estado)] || "cancelled";
  return (
    <span className={`crm-rollo__chip crm-rollo__chip--status crm-rollo__chip--${tone}`}>{labelFor(ESTADO_LABELS, estado)}</span>
  );
}

// PriorityChip: almost square chip with level bars so Crítica and Alta differ beyond color.
export function PriorityChip({ prioridad }) {
  const level = PRIORIDAD_LEVELS[codeOf(prioridad)] || { tone: "low", bars: 0 };
  return (
    <span className={`crm-rollo__chip crm-rollo__chip--prio crm-rollo__chip--prio-${level.tone}`}>
      <span className="crm-rollo__bars" aria-hidden="true">
        {[1, 2, 3, 4].map((bar) => (
          <i key={bar} className={bar <= level.bars ? "is-on" : undefined} />
        ))}
      </span>
      {labelFor(PRIORIDAD_LABELS, prioridad)}
    </span>
  );
}

export function OrigenChip({ origen }) {
  return <span className="crm-rollo__chip crm-rollo__chip--origen">{labelFor(ORIGEN_LABELS, origen)}</span>;
}

// Amber tag (warn tokens) for demora and for a delivered quantity that differs from the requested one.
export function LateTag({ title, children }) {
  return (
    <span className="crm-rollo__late" title={title}>
      {children}
    </span>
  );
}
